import { render, staticRenderFns } from "./IrregularRequests.vue?vue&type=template&id=11830795"
import script from "./IrregularRequests.vue?vue&type=script&lang=js"
export * from "./IrregularRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports